import Vue    from 'vue'
import Router from 'vue-router'

import Dashboard from '../views/Dashboard.vue'

import Admins      from '../views/Admins.vue'
import AdminList   from '../views/admins/AdminList.vue'
import AdminEdit   from '../views/admins/AdminEdit.vue'
import AdminCreate from '../views/admins/AdminCreate.vue'

import Images      from '../views/Images.vue'
import ImageList   from '../views/images/ImageList.vue'
import ImageEdit   from '../views/images/ImageEdit.vue'
import ImageCreate from '../views/images/ImageCreate.vue'

import Discounts      from '../views/catalog/Discounts.vue'
import DiscountList   from '../views/catalog/discounts/DiscountList.vue'
import DiscountEdit   from '../views/catalog/discounts/DiscountEdit.vue'
import DiscountCreate from '../views/catalog/discounts/DiscountCreate.vue'

import Pages      from '../views/Pages.vue'
import PageList   from '../views/pages/PageList.vue'
import PageCreate from '../views/pages/PageCreate.vue'
import PageEdit   from '../views/pages/PageEdit.vue'

import Orders         from '../views/Orders.vue'
import CreateOrder    from "../views/orders/CreateOrder.vue"
import NewOrders      from "../views/orders/NewOrders.vue"
import PrintedOrders  from "../views/orders/PrintedOrders.vue"
import ArchivedOrders from "../views/orders/ArchivedOrders.vue"
import PastOrders from "../views/orders/PastOrders.vue"
import VoidedOrders   from "../views/orders/VoidedOrders.vue"
import OrderView      from '../views/orders/OrderView.vue'
import AllOrders      from '../views/orders/AllOrders.vue'

import Users      from '../views/Users.vue'
import User       from '../views/users/User.vue'
import UserCreate from "../views/users/UserCreate.vue"
import UserList   from "../views/users/UserList.vue"

import Mailing       from '../views/Mailing.vue'
import Requests      from '../views/mailing/Requests.vue'
import Subscriptions from '../views/mailing/Subscriptions.vue'
import EmailList     from '../views/mailing/EmailList.vue'

import Catalog from '../views/Catalog.vue'

import Products      from '../views/catalog/Products.vue'
import ProductEdit   from "../views/catalog/products/ProductEdit.vue"
import ProductCreate from "../views/catalog/products/ProductCreate.vue"
import ProductList   from "../views/catalog/products/ProductList.vue"

import Bundles      from "../views/catalog/Bundles.vue"
import BundleList   from "../views/catalog/bundles/BundleList.vue"
import BundleCreate from "../views/catalog/bundles/BundleCreate.vue"
import BundleEdit   from "../views/catalog/bundles/BundleEdit.vue"

import Categories     from "../views/catalog/Categories.vue"
import CategoryList   from "../views/catalog/categories/CategoryList.vue"
import CategoryCreate from "../views/catalog/categories/CategoryCreate.vue"
import CategoryEdit   from "../views/catalog/categories/CategoryEdit.vue"

import Items      from "../views/catalog/Items.vue"
import ItemList   from "../views/catalog/items/ItemList.vue"
import ItemCreate from "../views/catalog/items/ItemCreate.vue"
import ItemEdit   from "../views/catalog/items/ItemEdit.vue"

import Tags      from "../views/catalog/Tags.vue"
import TagList   from "../views/catalog/tags/TagList.vue"
import TagCreate from "../views/catalog/tags/TagCreate.vue"
import TagEdit   from "../views/catalog/tags/TagEdit.vue"

import Months from "../views/catalog/Months.vue"
import ReferralCodes from "../views/catalog/ReferralCodes.vue"

import Reports           from '../views/Reports.vue'
import ReportSummary     from '../views/reports/Summary.vue'
import EmailReport       from '../views/reports/Emails.vue'
import SalesByPackReport from '../views/reports/SalesByPack.vue'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'is-active',
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    if (savedPosition) {
      return savedPosition
    }
    else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    { path: '/', name: 'home', component: Dashboard },
    {
      path: '/mailing', component: Mailing, children: [
        { path: '', name: 'requests', component: Requests },
        { path: 'subscriptions', name: 'subscriptions', component: Subscriptions },
        { path: 'emails', name: 'email-list', component: EmailList },
      ]
    },
    {
      path: '/admins', component: Admins, children: [
        { path: '', name: 'admins', component: AdminList },
        { path: 'new', name: 'admin-create', component: AdminCreate },
        { path: ':id', name: 'admin', component: AdminEdit },
      ]
    },
    {
      path: '/images', component: Images, children: [
        { path: '', name: 'images', component: ImageList },
        { path: 'new', name: 'image-create', component: ImageCreate },
        { path: ':id', name: 'image', component: ImageEdit },
      ]
    },
    {
      path: '/catalog', component: Catalog, children: [
        {
          path: 'products', component: Products, children: [
            { path: '', name: 'products', component: ProductList },
            { path: 'new', name: 'product-create', component: ProductCreate },
            { path: ':id', name: 'product', component: ProductEdit },
          ]
        },
        {
          path: 'bundles', component: Bundles, children: [
            { path: '', name: 'bundles', component: BundleList },
            { path: 'new', name: 'bundle-create', component: BundleCreate },
            { path: ':id', name: 'bundle', component: BundleEdit },
          ]
        },
        {
          path: 'categories', component: Categories, children: [
            { path: '', name: 'categories', component: CategoryList },
            { path: 'new', name: 'category-create', component: CategoryCreate },
            { path: ':id', name: 'category', component: CategoryEdit },
          ]
        },
        {
          path: 'discounts', component: Discounts, children: [
            { path: '', name: 'discounts', component: DiscountList },
            { path: 'new', name: 'discount-create', component: DiscountCreate },
            { path: ':id', name: 'discount', component: DiscountEdit },
          ]
        },
        {
          path: 'items', component: Items, children: [
            { path: '', name: 'items', component: ItemList },
            { path: 'new', name: 'item-create', component: ItemCreate },
            { path: ':id', name: 'item', component: ItemEdit },
          ]
        },
        {
          path: 'tags', component: Tags, children: [
            { path: '', name: 'tags', component: TagList },
            { path: 'new', name: 'tag-create', component: TagCreate },
            { path: ':id', name: 'tag', component: TagEdit },
          ]
        },
        {
          path: 'months', name: 'months', component: Months,
        },
        {
          path: 'referral_sources', name: 'referral_sources', component: ReferralCodes,
        }
      ]
    },
    { path: '/new-order', name: 'new-order', component: CreateOrder },
    {
      path: '/orders', component: Orders, children: [
        { path: '', name: 'orders', component: NewOrders },
        { path: 'printed', name: 'printed-orders', component: PrintedOrders },
        { path: 'archived', name: 'archived-orders', component: ArchivedOrders },
        { path: 'past', name: 'past-orders', component: PastOrders },
        { path: 'voided', name: 'voided-orders', component: VoidedOrders },
        { path: ':id', name: 'order', component: OrderView },
        { path: 'all', name: 'all-orders', component: AllOrders },
      ]
    },
    {
      path: '/pages', component: Pages, children: [
        { path: '', name: 'pages', component: PageList },
        { path: 'new', name: 'page-create', component: PageCreate },
        { path: ':id', name: 'page', component: PageEdit },
      ]
    },
    {
      path: '/users', component: Users, children: [
        { path: '', name: 'users', component: UserList },
        { path: 'new', name: 'user-create', component: UserCreate },
        { path: ':id', name: 'user', component: User },
      ]
    },
    {
      path: '/reports', component: Reports, children: [
        { path: '', name: 'reports', component: ReportSummary },
        { path: 'product-sold-count', name: 'sales-by-pack', component: SalesByPackReport },
        { path: 'emails', name: 'email-report', component: EmailReport },
      ]
    }
  ]
})



//////////////////
// WEBPACK FOOTER
// ./vue/src/router/index.js
// module id = 233
// module chunks = 0